import * as React from 'react';
import { Layout } from './components/Layout';
import { RegisterPage } from './pages/RegisterPage';
import { WelcomePage } from './pages/WelcomePage';
import { InfoPage } from './pages/InfoPage';
import { FilesPage } from './pages/FilesPage';
import { StatementPage } from './pages/StatementPage';
import { ModalMessage } from './pages/ModalMessage';
import { observer } from 'mobx-react-lite';
import { useStores } from './stores/Hooks';
import { YandexCaptchaComponent } from './components/YandexCaptchaComponent';
import { Switch, Route } from "react-router-dom";
import { useHistory, useLocation } from 'react-router-dom';

declare global
{
	interface Window { grecaptcha: any; }
}

export const App: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const history = useHistory();
		uiState.setHistory(history);
		const { search } = useLocation();
		uiState.setSearch(search);

		if (uiState.IsLoading)
		{
			return (
				<>
					<Layout CurrentPage={0}>
					</Layout>
					<ModalMessage />
				</>
			);
		}

		return (
			<>
				<Switch>
					<Route path="/" exact>
						<Layout CurrentPage={0}>
							<WelcomePage />
						</Layout>
					</Route>
					<Route path="/register">
						<Layout CurrentPage={1}>
							<RegisterPage />
						</Layout>
					</Route>
					<Route path="/info">
						<Layout CurrentPage={2}>
							<InfoPage />
						</Layout>
					</Route>
					<Route path="/files">
						<Layout CurrentPage={3}>
							<FilesPage />
						</Layout>
					</Route>
					<Route path="/statement">
						<Layout CurrentPage={4}>
							<StatementPage />
						</Layout>
					</Route>
					<Route>
						<h1>Not Found {history.location.pathname} </h1>
					</Route>
				</Switch>
				<ModalMessage />
				<YandexCaptchaComponent />
			</>
		);
	}
)